import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_JOB } from './job.reducer';

const loadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_JOB].sendingMessageLoading;
const getMessageSendSuccessful = (appState: any) => appState[STORE_FEATURE_KEY_JOB].messageSendSuccessful;

@Injectable()
export class JobSelectors {
    constructor(private store: Store<any>) {
    }

    selectLoading(): Observable<boolean> {
        return this.store
            .pipe(select(loadingSelector));
    }

    selectGetMessageSendSuccessful(): Observable<any> {
        return this.store
            .pipe(select(getMessageSendSuccessful));
    }
}
